<form novalidate
  [formGroup]="_form"
  (keydown.enter)="$event.preventDefault()"
  class="form_style">
  <div class="row">
    <div class="col-12">
      <div class="transaction-section-header">
        <div class="transaction-section-header-title">
          @if (!showTextBox) {
            <div (dblclick)="showTextbox()" class="">{{title}}</div>
          }
          <div>
            @if (showTextBox) {
              <input type="text"
                #titleTextBox
                [value]="title"
                id="titleTextBox"
                (blur)="closeTextbox($event.target)"
                (keyup.enter)="closeTextbox($event.target)" />
            }
          </div>
        </div>
        <div class="transaction-section-header-actions header-actions">
          @if (_cycleCountChunksDetails.length > 0) {
            <button class="hidden-xs asap-btn" kendoButton (click)="_process()">
              <span>
                <img [src]="'/assets/menu/'+ _theme +'/proccess-icon.svg'" />
              </span>Process
            </button>
          }
          @if (_cycleCountChunksDetails.length > 0) {
            <button class="hidden-xs asap-btn" kendoButton (click)="_processAndClose()">
              <span>
                <img [src]="'/assets/menu/'+ _theme +'/save-close-icon.svg'" />
              </span>Process & Close
            </button>
          }
          @if (_cycleCountChunksDetails.length > 0) {
            <button class="hidden-xs asap-btn" kendoButton (click)="_export()">
              <span>
                <img [src]="'/assets/menu/'+ _theme +'/print-icon.svg'" />
              </span>Export PDF
            </button>
          }
          <button class="hidden-xs asap-btn" kendoButton (click)="_reset()">
            <span>
              <img [src]="'/assets/menu/'+ _theme +'/clear-icon.svg'" />
            </span>Clear
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row no-row-margin">
    <!-- Step 1: Configuration / Selection -->
    <div class="col-12 col-lg-6 small-pad-right">
      <div class="transactionWidget">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <p class="titleStandardStyle mb-0">Step 1: Selection</p>
            </div>
          </div>

          <div class="col-12 margin-top-10">
            <div class="form-group special_style_formgroup">
              <div class="row">
                <div class="col-2">
                  <label class="control-label">Date - Time</label>
                </div>
                <div class="col-10 transaction-input-fields">
                  <kendo-datetimepicker class="k-datepicker datepickerControlrightMargin"
                    #kendo_Start_Date_Time_Piker
                    [disabled]="!_dateEnabled || _cycleCountChunksDetails.length > 0"
                    formControlName="transactionDate"
                    placeholder="Set Date and Time"
                    [format]="_datePickerFormat"
                    (valueChange)="_startDateSubmited()"
                    (open)="_startDateOpened()">
                  </kendo-datetimepicker>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 margin-top-10">
            <div class="form-group special_style_formgroup">
              <div class="row">
                <div class="col-2">
                  <label class="control-label">Cycle Chunk *</label>
                </div>
                <div class="col-10 transaction-input-fields">
                  <kendo-combobox [data]="_cycleCountChunksFiltered"
                    [suggest]="true"
                    [filterable]="true"
                    (filterChange)="_handleCycleCountChunksFilter($event)"
                    [textField]="'name'"
                    [valueField]="'id'"
                    formControlName="cycleCountChunk"
                    (valueChange)="onChunkChange($event)"
                    (open)="_cycleCountChunksFiltered = _cycleCountChunks"
                    [disabled]="_cycleCountChunksDetails.length > 0"
                    placeholder="Select Unadjusted Chunk"
                    class="bordered newFormControlWidth">
                  </kendo-combobox>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 mt-3">
            <hr>
              <small class="text-muted d-block mb-1">* Select an unadjusted cycle count chunk to review and adjust variances.</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 2: Show / Check All -->
      <div class="col-12 col-lg-6 small-pad-left">
        <div class="transactionWidget"
          (click)="_listboxClicked()"
          [class.active]="_addClassActiveLocation">
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <p class="titleStandardStyle mb-0">Step 2: Review Discrepancies</p>
                @if (_cycleCountChunksDetails.length > 0) {
                  <div class="d-flex align-items-center">
                    <span class="badge badge-info px-2 py-1 mr-2" style="font-size: 13px; border-radius: 6px;">
                      Items: {{_cycleCountChunksDetails.length}}
                    </span>
                  </div>
                }
              </div>
            </div>

            @if (_cycleCountChunksDetails.length === 0) {
              <div class="col-12 margin-top-10">
                <p class="text-muted mb-3" style="font-size: 13px;">
                  Select configuration options in Step 1, then click below to show all discrepancy records.
                </p>
                <button kendoButton
                  class="asap-btn"
                  (click)="_showAllVariance()">
                  Show All Variances
                </button>
              </div>
            }

            @if (_cycleCountChunksDetails.length > 0) {
              <div class="col-12 margin-top-10">
                <p class="text-success mb-0 pt-2" style="font-size: 13px;">
                  Discrepancies loaded successfully. Review and select items to adjust in the table below.
                </p>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Validation Summary -->
      @if (_invalidForm) {
        <div class="row w-100 mx-0">
          <div class="col-12">
            <asap-forms-validation-summary [form]="_form" [page]="page">
            </asap-forms-validation-summary>
          </div>
        </div>
      }

      <!-- Variance Grid -->
      @if (_cycleCountChunksDetails.length > 0) {
        <div class="col-12 mt-3">
          <div class="asap-section-container with-grid"
            (click)="_gridclicked()"
            [class.active]="_addClassActiveGrid">
            <div class="row zeromarginRow align-items-center mb-2 px-3 pt-3">
              <div class="col-12">
                <p class="titleStandardStyle mb-0">
                  <span>Discrepancies Found: </span>
                  <span class="autoGenerateSection">
                    <strong>{{_cycleCountChunksDetails.length}}</strong>
                  </span>
                  <span class="autoGenerateSection ml-3 no-hover">
                    <span>
                      <input type="checkbox"
                        id="adjust-all-checkbox"
                        class="k-checkbox"
                        kendoCheckBox
                        (click)="_selectAdjustAll()"
                        [checked]="_allSelected" />
                        <label class="control-label autoGenerateLabel cursor-pointer mb-0" for="adjust-all-checkbox">Adjust All</label>
                      </span>
                    </span>
                  </p>
                </div>
              </div>
              <div #gridWrapper>
                <kendo-grid [data]="_cycleCountChunksDetails"
                  #grid
                  [selectable]="{ checkboxOnly: true, mode: 'multiple' }"
                  [kendoGridSelectBy]="selectBy"
                  [selectedKeys]="_selectedKeys"
                  (selectedKeysChange)="_onGridSelectionChange($event)"
                  [resizable]="true"
                  class="asap-standalone-grid">
                  <kendo-grid-checkbox-column [width]="50"
                    [showSelectAll]="true"
                    class="text-center"
                    headerClass="text-center">
                  </kendo-grid-checkbox-column>
                  <kendo-grid-column field="stockItemCode" title="Item Code" [width]="130">
                  </kendo-grid-column>
                  <kendo-grid-column field="stockItemDescription" title="Description" [width]="170">
                  </kendo-grid-column>
                  <kendo-grid-column field="inventoryNumber" title="Inventory #" [width]="130">
                  </kendo-grid-column>
                  <kendo-grid-column field="expectedLocationName" title="Expected Location" [width]="140">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <span>{{dataItem.expectedLocationName || dataItem.expectedLocationCode || ''}}</span>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="actualLocationName" title="Actual Location" [width]="140">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <span>{{dataItem.actualLocationName || dataItem.actualLocationCode || ''}}</span>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="expectedQuantity" title="Expected Qty" [width]="105">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <span>{{dataItem.expectedQuantity | number:'1.0-2'}}</span>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="actualQuantity" title="Actual Qty" [width]="105">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <span>{{dataItem.actualQuantity | number:'1.0-2'}}</span>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="varianceQuantity" title="Variance" [width]="95">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="text-danger font-weight-bold">
                        {{((dataItem.actualQuantity || 0) - (dataItem.expectedQuantity || 0)) | number:'1.0-2'}}
                      </span>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="varianceReason" title="Reason / Notes" [width]="170">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <input type="text"
                        class="k-textbox writebox"
                        [(ngModel)]="dataItem.varianceReason"
                        [ngModelOptions]="{standalone: true}" />
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-pdf [fileName]="_exportFileName + '.pdf'"
                      paperSize="A4"
                      [allPages]="true"
                      [repeatHeaders]="true"
                      [landscape]="true"
                      [scale]="0.5">
                      <kendo-grid-pdf-margin top="2cm"
                        left="1cm"
                        right="1cm"
                        bottom="2cm">
                      </kendo-grid-pdf-margin>
                      @for (item of _pdfColumns; track item) {
                        <kendo-grid-column
                          [title]="item.name"
                          [field]="item.field"
                          [width]="item.width">
                        </kendo-grid-column>
                      }
                    </kendo-grid-pdf>
                  </kendo-grid>
                </div>
              </div>
            </div>
          }
        </div>
      </form>
